import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select"
import redirectURL from "../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import { MdOutlineFileUpload } from "react-icons/md";
import "../../assets/css/inventorymanagement.css"

const PinCodeMappingDashboard = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [file, setFile] = useState(null);

  const [store, setStore] = useState(null);
  const [storeOptions, setStoreOptions] = useState([]);

  const columnDefs = [
    { headerName: "Pincode", field: "pincode",  },
    { headerName: "Destination Store Name", field: "destination_store_name",  },
    { headerName: "Destination Store ID", field: "destination_store_id"},
    { headerName: "Warehouse", field: "warehouse",hide:true},
    { 
      headerName: "Inserted Date", 
      field: "inserted_date",
      valueFormatter: params => params.value ? new Date(params.value).toLocaleDateString('en-GB') : '',
      hide: true,
    },
    { 
      headerName: "Updated Date", 
      field: "updated_date",
      valueFormatter: params => params.value ? new Date(params.value).toLocaleDateString('en-GB') : '',
      hide:true,
    }
  ];

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    // flex: 1,
    // minWidth: 100
  }

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getPinMappingData();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const getStoreOptions = async () => {
    try {
      const response = await redirectURL.post("masters/getPinMappingStores", {});
      
      if (response.status === 200) {
        setStoreOptions(response.data.stores);
        setStore(response.data.stores[0]); 
      } else {
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch store options");
      setBasicType("error");
      setShow(true);
    }
  }

  const getPinMappingData = async () => {
    try {
      const response = await redirectURL.post("masters/getPinMappingData", {});
      
      if (response.status === 200) {
        setRowData(response.data.data);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setBasicTitle("Failed to fetch pin mapping data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getPinMappingDataByFilter = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = {};

    if (store && store.value) {
      params.store = store.value;
    }

    try { 
      const response = await redirectURL.post(
        "masters/getPinMappingDataByFilter",
        params
      );
      const data = response.data.data;
      setRowData(data);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Error Failed to get Pin Mapping Data");
    }
  };

  const setFilters = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    await getPinMappingDataByFilter();
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  }

  const resetFilters = async () => {
    setStore(storeOptions[0]); // Reset to ALL
    await getMainData();
  }

  const downloadExcelTemplate = () => {
    const sampleData = [
      ["Pincode", "Warehouse" ,"Store Type"],
      ["110001", "Gurgaon DS1","darkstore"],
      ["400001", "Bhiwandi WH","warehouse"],
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "PinCodeMappingTemplate");
    writeFile(wb, "pincode_mapping_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value);
    
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

      const mapping = {
        "Pincode": "pincode",
        "Warehouse": "warehouse",
      "store type":"store_type"
      };

      function toSnakeCase(str) {
        return str
          .trim()
          .replace(/\s+/g, '_')
          .replace(/[A-Z]/g, letter => letter.toLowerCase())
          .replace(/[^a-z0-9_]/g, '');
      }

      const result = parsedData.map(item => {
        const newItem = {};
        for (const key in item) {
          if (mapping[key]) {
            newItem[mapping[key]] = item[key];
          } else {
            newItem[toSnakeCase(key)] = item[key];
          }
        }
        return newItem;
      });

      // console.log("Parsed PinCode Mapping Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const onClickingFileSubmit = async () => {
    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a valid file");
      return;
    }

    const params = { data: uploadedFileData };
    
    try {
      const response = await redirectURL.post(
        "masters/UploadPincodeMappingData",
        params
      );
             const backendStatus = response.data.response.status;
      
      if (response.data.status === "success" & backendStatus === "Success") {
        const beckendMessage= response.data.response?.message || "Data Uploaded Successfully";
        console.log(beckendMessage);
 
        setUploadedFileData([]);
        await getPinMappingData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle(beckendMessage);
        hideOverlySlideBlock();
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Bulk Uploaded PinCode Mapping",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(response.data?.response?.message|| "Data Upload Failed");
        
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Bulk Uploaded PinCode Mapping",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An error occurred";
      setUploadedFileData([]);
      setShow(true);
      setBasicType("info");
      setBasicTitle(errorMessage);
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Bulk Uploaded PinCode Mapping",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const onClickUploadPinCodeMapping = () => {
    setUploadedFileData([]);
    setSliderOpen(true);
    setSliderTitle("Upload PinCode Mapping Data");
    setOverlyBlock("show-m");
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setUploadedFileData([]);
    setFile(null);
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setUploadedFileData([]);
    setFile(null);
  };

  useEffect(() => {
    const initializeData = async () => {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      await getStoreOptions();
      await getPinMappingData();
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    };
    
    initializeData();
  }, []);

  const closeAlert = () => {
    setShow(false);
    setBasicType("default");
    setBasicTitle("");
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setSliderOpen(false)
    setUploadedFileData([])
    setFile(null)
     if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="row" style={{fontSize: "0.9rem", fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12 p-0">
            <h1 className="col-sm-12" style={{color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif"}}>
              Pincode - Warehouse Mapping
            </h1>
          </div>

          <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-10 row ">
              <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="store" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Destination Store:
                </label>
                <Select
                  id="store"
                  value={store}
                  onChange={setStore}
                  options={storeOptions}
                  styles={selectStyles}
                  placeholder="Select Store"
                />
              </div>
              
              <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                <button 
                  type="button" 
                  onClick={setFilters}
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Apply
                </button>
                <button 
                  onClick={resetFilters}
                  type="button" 
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderRadius: "5px",
                    padding: "8px 20px",
                    border: "1px solid #d9d9d9",
                    cursor: "pointer"
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            {/* Upload Button */}
            <div className="col-sm-2 d-flex justify-content-end">
              <button
                type="button"
                onClick={onClickUploadPinCodeMapping}
                className="mr-2"
                style={{
                  ...addButtonStyle,
                  backgroundColor: "#F4EBEF",
                  color: "#93385D",
                  border: "2px solid #93385D",
                }}
              >
                <MdOutlineFileUpload style={{ color: "#93385D", fontSize :"20px" }} />
                 &nbsp;
                Upload
              </button>
            </div>
          </form>

          <div className="col-sm-12 p-0 pl-2 mt-3">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={1000}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bulk Upload Slider */}
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} slider-25`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>
        
        <div style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding: 5 }}>
          <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
            <div className="d-flex justify-content-end mb-10p">
              <button
                id="sample-download-button"
                onClick={downloadExcelTemplate}
              >
                {"Download Sample Template"}
              </button>
            </div>
            <input
              type="file"
              accept=".csv,.xlsx,.xls"
              onChange={handleFileChange}
              style={{
                border: "1px solid lightgrey",
                width: "100%",
                padding: "8px",
                borderRadius: "5px",
                backgroundColor: "#f9f9f9",
                color: "#000",
                fontSize: "13px",
              }}
              value={file}
              id="bulkUploadFile"
            />
            <p style={{ color: "red", fontSize: "13px", margin: "0px", marginTop: "10px" }}>
              *Accept .csv & .xlsx files only
            </p>
            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <button
                style={{ backgroundColor: "#93385D", color: "#fff", fontSize: "0.8rem" }}
                onClick={(e) => {
                  setLoadshow("show-m");
                  setOverlayBlock("show-m");
                  onClickingFileSubmit(e);
                }}
              >
                {"Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </>
  );
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
    minHeight: '35px'
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: '#333',
    fontSize: '12px'
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '13px',
    fontWeight: state.isSelected ? 'normal' : 'normal',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '4px'
  })
};
const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily :"sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

export default PinCodeMappingDashboard;